import axios from '@shared/axios-shared';
import { unwrap } from './errors';

// Pre-auth (email-link) endpoints — throttled server-side.
export const getLinkContext = (t) => axios.get('/api/v2/hosted/billing/context', { params: { t } }).then(unwrap);

export const verifyLink = (t, studentLastName) =>
	axios.post('/api/v2/hosted/billing/verify', { t, student_last_name: studentLastName }).then(unwrap);

// Session-scoped parent billing endpoints (Bearer header set by session.js).
export const getAutoPayStatus = (studentId) =>
	axios.get('/api/v2/parent/billing/auto-pay', { params: { student_id: studentId } }).then(unwrap);

export const toggleAutoPay = (assignmentId, payload) =>
	axios.post(`/api/v2/parent/billing/assignments/${assignmentId}/auto-pay`, payload).then(unwrap);

export const listPaymentMethods = (studentId) =>
	axios.get('/api/v2/parent/billing/payment-methods', { params: { student_id: studentId } }).then(unwrap);

export const createSetupIntent = (studentId) =>
	axios.post('/api/v2/parent/billing/payment-methods/setup-intent', { student_id: studentId }).then(unwrap);

export const setDefaultPaymentMethod = (paymentMethodId, studentId) =>
	axios
		.patch(`/api/v2/parent/billing/payment-methods/${paymentMethodId}/default`, { student_id: studentId })
		.then(unwrap);

export const listOpenInvoices = (studentId) =>
	axios
		.get('/api/v2/parent/billing/invoices', {
			params: { student_id: studentId, status: ['due', 'past_due'] },
		})
		.then(unwrap);

export const getInvoiceStripeUrl = (invoiceId) =>
	axios.get(`/api/v2/parent/billing/invoices/${invoiceId}/stripe-url`).then(unwrap);
